import {React, useEffect, useState} from "react";
import taxi from "../images/taxi-image.png";
import MyButton from "../components/MyButton";
import LoadingComponent from "../components/LoadingComponent";
import getCarrers from "../handles/getCarrers";

const SetQuiz = (props) => {
  const setCurrentPage = props.changePage;
  const setNumPreguntes = props.changePreguntes;
  const setData = props.setData;

  const [currentNumber, setCurrentNumber] = useState(10);
  const [validInput, setValidInput] = useState(true);
  const [loading, setLoading] = useState(false);
  const max = 50;

  const handleButtonClick = async () => {
    setLoading(true);
    const dataCarrers = await getCarrers(currentNumber);
    setNumPreguntes(currentNumber);
    setData(dataCarrers);
    setLoading(false);
    setCurrentPage("quiz");
  };


  const goBack = () => {
    // Your custom button click logic here
    setCurrentPage("main");
  };


  useEffect(() => {
    if (currentNumber < max && currentNumber > 0 ) {
      setValidInput(true);
    } else {
      setValidInput(false);
    }
  }, [currentNumber]);

  const inputNumber = (e) => {
    setCurrentNumber(e.target.value);
    console.log(e.target.value);
  };

  return (
    <div className="mx-10">
      {loading && <LoadingComponent/>}
      <img src={taxi} className="mb-10" alt="taxi" />
      <div>Quantes preguntes vols al quiz?</div>
      <div className="my-10">
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="grid-zip"
          type="number"
          placeholder={`Màxim ${max} preguntes`}
          max={max}
          onInput={inputNumber}
          value={currentNumber}
        />
      </div>
      <div className="button-Container">
        <MyButton label="Començar!" onPress={handleButtonClick} disabled={!validInput || loading}/>
      </div>
      <div className="button-Container">
        <MyButton label="Back" onPress={goBack} disabled={loading} color="red"/>
      </div>
    </div>
  );
};
export default SetQuiz;
